/**
 * Used for overriding the default behavior of Shoptet splitMenu function.
 *
 * The splitMenu function performs the following steps:
 * 1. Select the `navigation-in` element
 * 2. If the element is found, set a timer for 200 ms
 * 3. After the timer expires:
 *  a. Select all first-level menu items that do not have the `appended-category` class
 *  b. Select the element with the `menu-helper` class
 *  c. Get the computed style for the menu element
 *  d. For each menu item:
 *      i. Calculate the right offset of the item
 *      ii. Check if the item is in the `menu-helper` (special case for the item with the ID `nav-manufacturers`)
 *      iii. If the right offset is greater than the menu width minus the right padding, add the `splitted` class to the menu item and remove it from the `menu-helper`
 *      iv. If the right offset is less than or equal to the menu width minus the right padding, add the `splitted` class to the item in the `menu-helper` and remove it from the menu item
 *  e. Check if there are any unsplitted items in the `menu-helper`
 *      i. If yes, remove the `empty` class from the `menu-helper` and the `fitted` class from the menu
 *      ii. If no, add the `empty` class to the `menu-helper` and the `fitted` class to the menu
 */
const splitMenu = () => {
  const menuWrapper = document.querySelector("#navigation .navigation-in");
  if (menuWrapper) {
    setTimeout(() => {
      let menuItems = menuWrapper.querySelectorAll(
        ".menu-level-1>li:not(.appended-category)"
      );
      let menuHelper = document.querySelector(".menu-helper");
      // console.log(menuHelper.querySelectorAll('.menu-level-1 > li'))
      let menuWrapperStyle = window.getComputedStyle(menuWrapper);
      // console.log(menuWrapperStyle.paddingRight)
      let navInOffestLeft;
      if (window.innerWidth > 1504) {
        navInOffestLeft = menuWrapper.offsetLeft;
      } else navInOffestLeft = 0;
      menuItems.forEach((item) => {
        let offsetRight = item.offsetLeft + item.offsetWidth;
        // console.log(offsetRight, menuWrapper.clientWidth - parseFloat(menuWrapperStyle.paddingRight))
        // console.log(item.offsetLeft, item.offsetWidth)

        const itemInHelper =
          item.id === "nav-manufacturers"
            ? menuHelper.querySelector("#nav-manufacturers")
            : menuHelper.querySelector("." + item.classList[0]);
        if (
          offsetRight - navInOffestLeft >
          menuWrapper.clientWidth - parseFloat(menuWrapperStyle.paddingRight)
        ) {
          if (itemInHelper) {
            itemInHelper.classList.remove("splitted");
            // console.log(itemInHelper, 'remove-splitted')
          }
          item.classList.add("splitted");
        } else {
          if (itemInHelper) {
            itemInHelper.classList.add("splitted");
            // console.log(itemInHelper, itemInHelper.classList, 'add-splitted')
          }
          item.classList.remove("splitted");
        }
      });
      if (
        menuHelper.querySelector(
          ".menu-level-1 > li:not(.splitted):not(.appended-category)"
        )
      ) {
        menuHelper.classList.remove("empty");
        menuWrapper.classList.remove("fitted");
        menuHelper.classList.add("visible");
      } else {
        menuHelper.classList.add("empty");
        menuWrapper.classList.add("fitted");
        menuHelper.classList.remove("visible");
      }
    }, 500);
  }
};

/**
 * Used for overriding the default behavior of Shoptet splitMenu function.
 *
 * This function is used to split the menu with manufacturers.
 * Functionality is the same as the splitMenu function, but it also checks for the `nav-manufacturers` element.
 * The splitMenu function performs the following steps:
 * 1. Select the `navigation-in` element
 * 2. If the element is found, set a timer for 200 ms
 * 3. After the timer expires:
 *  a. Select all first-level menu items that do not have the `appended-category` class
 *  b. Select the element with the `menu-helper` class
 *  c. Get the computed style for the menu element
 *  d. For each menu item:
 *      i. Calculate the right offset of the item
 *      ii. Check if the item is in the `menu-helper` (special case for the item with the ID `nav-manufacturers`)
 *      iii. If the right offset is greater than the menu width minus the right padding, add the `splitted` class to the menu item and remove it from the `menu-helper`
 *      iv. If the right offset is less than or equal to the menu width minus the right padding, add the `splitted` class to the item in the `menu-helper` and remove it from the menu item
 *  e. Check if there are any unsplitted items in the `menu-helper`
 *      i. If yes, remove the `empty` class from the `menu-helper` and the `fitted` class from the menu
 *      ii. If no, add the `empty` class to the `menu-helper` and the `fitted` class to the menu
 */
const splitMenuWithManufacturers = () => {
  console.log("splitMenuWithManufacturers");

  const menuWrapper = document.querySelector("#navigation .navigation-in");
  if (menuWrapper) {
    setTimeout(() => {
      let menuItems = menuWrapper.querySelectorAll(
        ".menu-level-1>li:not(.appended-category):not(#nav-manufacturers)"
      );
      let menuHelper = document.querySelector(".menu-helper");

      menuItems.forEach((item) => {
        let offsetRight = item.offsetLeft + item.offsetWidth;
        console.log(offsetRight, menuWrapper.clientWidth);

        if (offsetRight > menuWrapper.clientWidth) {
          let splitted;
          if (!item.id == "nav-manufacturers") {
            splitted = menuHelper.querySelector("." + item.classList[0]);
          } else {
            splitted = menuHelper.querySelector("#nav-manufacturers");
          }
          if (splitted) {
            splitted.classList.remove("splitted");
          }
          item.classList.add("splitted");
        } else {
          let splitted = menuHelper.querySelector("." + item.classList[0]);
          if (splitted) {
            splitted.classList.add("splitted");
          }
          item.classList.remove("splitted");
        }
      });
      if (
        menuHelper.querySelector(
          ".menu-level-1 > li:not(.splitted):not(.appended-category):not(#nav-manufacturers)"
        )
      ) {
        menuHelper.classList.remove("empty");
        menuWrapper.classList.remove("fitted");
        menuHelper.classList.add("visible");
      } else {
        menuHelper.classList.add("empty");
        menuWrapper.classList.add("fitted");
        menuHelper.classList.remove("visible");
      }
    }, 200);
  }
};

/**
 * Used for overriding the default behavior of Shoptet splitMenu function.
 * @param {boolean} hasManufaturers - If true, the splitMenuWithManufacturers function will be used, otherwise the splitMenu function will be used
 */
const overrideSplitMenu = (hasManufaturers = false) => {
  shoptet.menu.splitMenu = hasManufaturers
    ? splitMenuWithManufacturers
    : splitMenu;
};

/**
 * Simple debounce function. It delays the execution of the function by the specified delay.
 * @param {function} func - Function to be executed
 * @param {number} delay - Delay in milliseconds
 * @returns {function} - Debounced function
 */
const debounce = (func, delay) => {
  let debounceTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};

/**
 * Observes for the specified element and calls the callback function when the element is added to the DOM.
 * Use waitFor().then(() => {}) to wait for the element to be added to the DOM.
 * @param {string} selector - Selector for the element
 * @returns {Promise} - Promise that resolves when the element is added to the DOM
 */
const waitFor = async (selector) => {
  return new Promise((resolve, reject) => {
    const element = document.querySelector(selector);

    if (element) {
      resolve(element);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const nodes = [...mutation.addedNodes];
        for (const node of nodes) {
          if (node.matches && node.matches(selector)) {
            observer.disconnect();
            resolve(node);
            return;
          }
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
};

/**
 * Creates an element with the specified tag, classes, and text.
 * @param {string} tag - Tag name of the element
 * @param {Array} classes - Array of classes to be added to the element
 * @param {string} text - Text content of the element
 * @returns {HTMLElement} - Created element
 */
const createElement = (tag, classes = [], text = "") => {
  const element = document.createElement(tag);
  classes.forEach((className) => element.classList.add(className));
  element.textContent = text;
  return element;
};

/**
 * Adds an event listener to the back-to-top button that scrolls the page to the top.
 * You should add the `div#back-to-top` element to the DOM in HTML editor.
 */
const handleBackToTopClick = () => {
  const backToTop = document.querySelector("#back-to-top");
  if (backToTop) {
    backToTop.addEventListener("click", (e) => {
      e.preventDefault();
      window.scrollTo(0, 0);
    });
  }
};

/**
 * removes all commas from menu-level-3 li items
 * */
const removeCommasFromMenu = () => {
  const menuLevel3 = document.querySelectorAll(".menu-level-3 > li");
  if (menuLevel3.length) {
    menuLevel3.forEach((li) => {
      const text = li.lastChild.data;
      if (text) li.lastChild.data = text.replace(",", "");
    });
  }
};

const createSeeMoreButtonSubcategory = () => {
  const menuLevel3s = document.querySelectorAll(".menu-level-3");
  if (menuLevel3s.length) {
    menuLevel3s.forEach((menuLevel3) => {
      const menuItems = menuLevel3.querySelectorAll("li");
      if (menuItems.length > 5) {
        const seeMoreButton = createElement(
          "a",
          ["see-more"],
          window.language === "cs" ? "Více z kategorie" : "Viac z kategórie"
        );
        seeMoreButton.href = menuLevel3.parentElement.querySelector("a").href;
        seeMoreButton.classList.add("btn");
        menuLevel3.appendChild(seeMoreButton);
        for (let i = 5; i < menuItems.length; i++) {
          menuItems[i].style.display = "none";
        }
        // seeMoreButton.addEventListener('click', (e) => {
        // 	e.preventDefault()
        // 	for (let i = 5; i < menuItems.length; i++) {
        // 		menuItems[i].style.display = 'block'
        // 	}
        // 	seeMoreButton.remove()
        // })
      }
    });
  }
};
const turnTelToLink = () => {
  const phoneNumbers = document.querySelectorAll(".contact-box .tel");
  for (let number of phoneNumbers) {
    const link = number.querySelector("a");
    if (!link) {
      const newLink = createElement("a", ["tel"], number.textContent);
      const call = number.textContent.trim();
      console.log(call);

      newLink.href = "tel:" + number.textContent.trim().replace(" ", "");
      newLink.setAttribute("title", "Telefon");
      number.innerHTML = "";
      number.appendChild(newLink);
    }
  }
};

// creates links for each product block on homepage based on config from client in editor
const createProductBlockLinks = () => {
  if (
    typeof hpConfig != "undefined" &&
    typeof hpConfig?.productBlocks !== "undefined"
  ) {
    if (hpConfig.productBlocks.length) {
      console.log("hpConfig.productBlocks", hpConfig.productBlocks);
    }
    // for (block in hpConfig.productBlocks) {
    // 	const productsBlock = document.querySelector(`#products-${block}`)
    // 	if (productsBlock) {
    // 		if (hpConfig.productBlocks[block].button) {
    // 			// if (hpConfig.productBlocks[block].subtitle) {
    // 			// 	const blockSubtitle = document.createElement('p')
    // 			// 	blockSubtitle.innerHTML = hpConfig.productBlocks[block].subtitle
    // 			// 	blockHeadingWrapper.appendChild(blockSubtitle)
    // 			// }
    // 			if (hpConfig.productBlocks[block].button) {
    // 				const buttonsWrapper = document.createElement('div')
    // 				buttonsWrapper.classList.add('buttons-wrapper', 'buttons-center')
    // 				const button = document.createElement('a')
    // 				button.classList.add('btn', 'btn-secondary')
    // 				button.innerHTML = hpConfig.productBlocks[block].button.text
    // 				button.href = hpConfig.productBlocks[block].button.url
    // 				buttonsWrapper.appendChild(button)
    // 				productsBlock.appendChild(buttonsWrapper)
    // 			}
    // 		}
    // 	}
    // }
    if (hpConfig && hpConfig.productBlocks) {
      for (let block in hpConfig.productBlocks) {
        if (hpConfig.productBlocks.hasOwnProperty(block)) {
          const productsBlock = document.querySelector(`#products-${block}`);
          if (productsBlock) {
            if (hpConfig.productBlocks[block].button) {
              // if (hpConfig.productBlocks[block].subtitle) {
              // 	const blockSubtitle = document.createElement('p')
              // 	blockSubtitle.innerHTML = hpConfig.productBlocks[block].subtitle
              // 	blockHeadingWrapper.appendChild(blockSubtitle)
              // }
              // if (hpConfig.productBlocks[block].button) {
              const buttonsWrapper = document.createElement("div");
              buttonsWrapper.classList.add("buttons-wrapper", "buttons-center");
              const button = document.createElement("a");
              button.classList.add("btn", "btn-arrow");
              button.innerHTML = hpConfig.productBlocks[block].button.text;
              button.href = hpConfig.productBlocks[block].button.url;
              buttonsWrapper.appendChild(button);
              productsBlock.appendChild(buttonsWrapper);
              // }
            }
          }
        }
      }
    }
  }
};

const handleLastVisited = () => {
  // NAPOSLEDY PROHLIZENE
  const contentObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.classList && node.querySelector(".dkLabVisitedProductsBox")) {
          const whereToAppend = document.querySelector(
            ".homepage-box.welcome-wrapper"
          );
          if (whereToAppend) {
            whereToAppend.parentElement.insertBefore(node, whereToAppend);
          }
          contentObserver.disconnect();
        }
      });
    });
  });
  const indexContent = document.querySelector(".overall-wrapper");
  if (indexContent) contentObserver.observe(indexContent, { childList: true });
};

export {
  overrideSplitMenu,
  splitMenu,
  debounce,
  waitFor,
  createElement,
  handleBackToTopClick,
  createProductBlockLinks,
  handleLastVisited,
  turnTelToLink,
  removeCommasFromMenu,
  createSeeMoreButtonSubcategory,
};
